module.exports = __webpack_public_path__ + "static/hébergement-site-internet-b7bc4725d34928d97d349e9ff335a9ae.png";